import { IVolumeDTO } from '@/modules/audio/dto/volume.dto';
import { IVolume } from '@/modules/audio/entities/volume.entity';

export class VolumeMapper {
  static toPresentation(dto: IVolumeDTO): IVolume {
    return {
      audioVolume: dto.volumeAudio / 10,
      generalVolume: dto.volumeGeral / 10,
      musicVolume: dto.volumeMusica / 10,
    };
  }

  static toDTO(entity: IVolume): IVolumeDTO {
    return {
      volumeAudio: Math.ceil(entity.audioVolume * 10),
      volumeGeral: Math.ceil(entity.generalVolume * 10),
      volumeMusica: Math.ceil(entity.musicVolume * 10),
    };
  }
}
